<template>
    <div>
        <button class="py-2 px-6 bg-blue-600 text-white text-center rounded-full min-w-button" @click="click" :disabled="loading">
            <template v-if="loading">
                <div class="card-button-spinner">
                    <div class="payment-bounce1"></div>
                    <div class="payment-bounce2"></div>
                    <div class="payment-bounce3"></div>
                </div>
            </template>
            <template v-else>
                <slot></slot>
            </template>
        </button>
    </div>
</template>

<script>
    export default {
        name: "CardButton",
        props: {
            loading: {
                default: false
            }
        },
        data() {
            return {
            }
        },
        methods: {
            click() {
                this.$emit('click')
            }
        }
    }
</script>

<style scoped>
    /* Spinner */
    .card-button-spinner {
        width: 50px;
        text-align: center;
        margin: 0 auto;
    }

    .card-button-spinner > div {
        width: 8px;
        height: 8px;
        background-color: #fff;
        margin-right: 4px;

        border-radius: 100%;
        display: inline-block;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }

    .card-button-spinner .payment-bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .card-button-spinner .payment-bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% { -webkit-transform: scale(0) }
        40% { -webkit-transform: scale(1.0) }
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            -webkit-transform: scale(0);
            transform: scale(0);
        } 40% {
              -webkit-transform: scale(1.0);
              transform: scale(1.0);
          }
    }
</style>